import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AnnouncementForm from './components/AnnouncementForm';
import MessageLog from './components/MessageLog';
import Login from './components/Login';
import TemplatesPage from './components/TemplatesPage'; // Import TemplatesPage
import PrivateRoute from './components/PrivateRoute'; // Import PrivateRoute
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AnnouncementForm />
            </PrivateRoute>
          }
        />
        <Route
          path="/logs"
          element={
            <PrivateRoute>
              <MessageLog />
            </PrivateRoute>
          }
        />
        <Route
          path="/templates"
          element={
            <PrivateRoute>
              <TemplatesPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
